<template lang="html">

  <section class="wrapper home">

    <div class="encabezado" data="home"></div>

    <div class="content">

      <div class="claim-home">
        <h1>Agencia de Colocación de </h1>
        <h2>Centro San Valero</h2>
      </div>

      <div class="container claim-home-text">
        <p>
          La Agencia de Colocación de Centro San Valero es un servicio gratuito, ágil y personalizado que facilita el encuentro entre personas que buscan empleo y empresas que necesitan incorporar profesionales. 
          <br> 🎯 Más de 1.000 personas atendidas al año y una red consolidada de empresas colaboradoras. 
        </p>
      </div>


      <section class="ofertas-wrapper container row-between ais">
        <ofertas></ofertas>
        <accesos></accesos>
      </section>



      <!-- <comunicaciones></comunicaciones> -->

    </div>


  </section>

</template>

<script lang="js">

  import comunicaciones from '@/components/view-parts/home/comunicaciones';
  import ofertas from '@/components/view-parts/home/ofertas';

  import programasactivos from '@/components/view-parts/home/programas-activos';

  import accesos from '@/components/parts/accesos';

  export default {
    name: 'home',
    components: {
      'comunicaciones': comunicaciones,
      'programasactivos': programasactivos,
      'ofertas': ofertas,
      'accesos': accesos
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/views/home.vue